export const translations = {
    te: {
        // Navigation
        home: 'హోమ్',
        write: 'వ్రాయండి',
        myArticles: 'నా కథనాలు',
        admin: 'నిర్వాహకుడు',
        login: 'లాగిన్',
        logout: 'లాగౌట్',
        profile: 'ప్రొఫైల్',

        // Language
        language: 'భాష',

        // Common Actions
        save: 'సేవ్ చేయండి',
        saveDraft: 'డ్రాఫ్ట్ సేవ్ చేయండి',
        publish: 'ప్రచురించండి',
        edit: 'సవరించు',
        delete: 'తొలగించు',
        cancel: 'రద్దు చేయండి',
        confirm: 'నిర్ధారించండి',
        submit: 'సమర్పించండి',
        search: 'వెతకండి',
        clearSearch: 'శోధన తొలగించు',
        viewMore: 'మరింత చూడండి',
        view: 'చూడండి',
        back: 'వెనక్కి',

        // Article Form
        title: 'శీర్షిక',
        titlePlaceholder: 'మీ కథనానికి శీర్షిక ఇవ్వండి...',
        slug: 'స్లగ్',
        slugHint: 'శీర్షిక నుండి స్వయంచాలకంగా రూపొందించబడింది, కానీ మీరు దీన్ని అనుకూలీకరించవచ్చు',
        category: 'వర్గం',
        tags: 'ట్యాగ్‌లు',
        tagsPlaceholder: 'రాజకీయాలు, భారతదేశం, బ్రేకింగ్ (కామాతో వేరుచేయబడినవి)',
        tagsHint: 'బహుళ ట్యాగ్‌లను కామాలతో వేరుచేయండి',
        coverImage: 'కవర్ చిత్రం',
        articleContent: 'కథన కంటెంట్',
        contentPlaceholder: 'మీ కథన కంటెంట్‌ను ఇక్కడ వ్రాయండి...',

        // Categories
        allCategories: 'అన్ని వర్గాలు',
        'andhra pradesh': 'ఆంధ్రప్రదేశ్',
        telangana: 'తెలంగాణ',
        politics: 'రాజకీయాలు',
        sports: 'క్రీడలు',
        technology: 'సాంకేతికత',
        entertainment: 'వినోదం',
        business: 'వ్యాపారం',
        health: 'ఆరోగ్యం',
        science: 'విజ్ఞానం',
        education: 'విద్య',
        lifestyle: 'జీవనశైలి',
        world: 'ప్రపంచం',
        spirituality: 'ఆధ్యాత్మికం',
        news: 'వార్తలు',
        crime: 'క్రైమ్',

        // Homepage
        featuredStories: 'ముఖ్య కథనాలు',
        topStories: 'ప్రముఖ కథనాలు',
        latestNews: 'తాజా వార్తలు',
        trendingNow: 'ప్రస్తుతం ట్రెండింగ్',
        categories: 'వర్గాలు',
        searchPlaceholder: 'శీర్షిక లేదా ట్యాగ్‌ల ద్వారా కథనాలు వెతకండి...',
        searchResults: 'శోధన ఫలితాలు',

        // Article Detail
        readTime: 'చదవడానికి సమయం',
        views: 'వీక్షణలు',
        publishedOn: 'ప్రచురించబడింది',
        author: 'రచయిత',
        relatedArticles: 'సంబంధిత కథనాలు',

        // Profile
        myProfile: 'నా ప్రొఫైల్',
        editProfile: 'ప్రొఫైల్ సవరించు',
        articlesPublished: 'ప్రచురించిన కథనాలు',
        totalViews: 'మొత్తం వీక్షణలు',
        role: 'పాత్ర',

        // Admin
        adminDashboard: 'నిర్వాహక డ్యాష్‌బోర్డ్',
        userManagement: 'వినియోగదారుల నిర్వహణ',
        articleModeration: 'కథన మోడరేషన్',
        users: 'వినియోగదారులు',
        articles: 'కథనాలు',
        featured: 'ముఖ్యమైనది',
        notFeatured: 'ముఖ్యమైనది కాదు',
        featureArticle: 'కథనాన్ని ముఖ్యంగా మార్చు',
        unfeaturedArticle: 'ముఖ్యత తొలగించు',
        currentRole: 'ప్రస్తుత పాత్ర',
        changeRole: 'పాత్ర మార్చండి',

        // Messages
        noArticles: 'కథనాలు లేవు',
        noSearchResults: 'శోధన ఫలితాలు లేవు',
        articleDeleted: 'కథనం విజయవంతంగా తొలగించబడింది',
        articleSaved: 'కథనం విజయవంతంగా సేవ్ చేయబడింది',
        articlePublished: 'కథనం విజయవంతంగా ప్రచురించబడింది',
        loading: 'లోడ్ అవుతోంది...',
        error: 'లోపం',
        success: 'విజయం',

        // Confirmation
        deleteConfirmTitle: 'కథనాన్ని తొలగించండి',
        deleteConfirmMessage: 'మీరు ఖచ్చితంగా తొలగించాలనుకుంటున్నారా?',
        cannotUndoAction: 'ఈ చర్య రద్దు చేయబడదు',

        // Login Modal
        welcomeMessage: 'TenTV న్యూస్‌కు స్వాగతం',
        signInMessage: 'కొనసాగించడానికి సైన్ ఇన్ చేయండి',
        continueWith: 'తో కొనసాగండి',
        sendLoginLink: 'లాగిన్ లింక్ పంపండి',
        emailPlaceholder: 'మీ ఇమెయిల్ నమోదు చేయండి',

        // Roles
        viewer: 'వీక్షకుడు',
        creator: 'సృష్టికర్త',
    },
    en: {
        // Navigation
        home: 'Home',
        write: 'Write',
        myArticles: 'My Articles',
        admin: 'Admin',
        login: 'Login',
        logout: 'Logout',
        profile: 'Profile',

        // Language
        language: 'Language',

        // Common Actions
        save: 'Save',
        saveDraft: 'Save Draft',
        publish: 'Publish',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        confirm: 'Confirm',
        submit: 'Submit',
        search: 'Search',
        clearSearch: 'Clear Search',
        viewMore: 'View More',
        view: 'View',
        back: 'Back',

        // Article Form
        title: 'Title',
        titlePlaceholder: 'Give your article a title...',
        slug: 'Slug',
        slugHint: 'Auto-generated from title, but you can customize it',
        category: 'Category',
        tags: 'Tags',
        tagsPlaceholder: 'politics, india, breaking (comma separated)',
        tagsHint: 'Separate multiple tags with commas',
        coverImage: 'Cover Image',
        articleContent: 'Article Content',
        contentPlaceholder: 'Write your article content here...',

        // Categories
        allCategories: 'All Categories',
        'andhra pradesh': 'Andhra Pradesh',
        telangana: 'Telangana',
        politics: 'Politics',
        sports: 'Sports',
        technology: 'Technology',
        entertainment: 'Entertainment',
        business: 'Business',
        health: 'Health',
        science: 'Science',
        education: 'Education',
        lifestyle: 'Lifestyle',
        world: 'World',
        spirituality: 'Spirituality',
        news: 'News',
        crime: 'Crime',

        // Homepage
        featuredStories: 'Featured Stories',
        topStories: 'Top Stories',
        latestNews: 'Latest News',
        trendingNow: 'Trending Now',
        categories: 'Categories',
        searchPlaceholder: 'Search articles by title or tags...',
        searchResults: 'Search Results',

        // Article Detail
        readTime: 'Read Time',
        views: 'Views',
        publishedOn: 'Published On',
        author: 'Author',
        relatedArticles: 'Related Articles',

        // Profile
        myProfile: 'My Profile',
        editProfile: 'Edit Profile',
        articlesPublished: 'Articles Published',
        totalViews: 'Total Views',
        role: 'Role',

        // Admin
        adminDashboard: 'Admin Dashboard',
        userManagement: 'User Management',
        articleModeration: 'Article Moderation',
        users: 'Users',
        articles: 'Articles',
        featured: 'Featured',
        notFeatured: 'Not Featured',
        featureArticle: 'Feature Article',
        unfeaturedArticle: 'Unfeature',
        currentRole: 'Current Role',
        changeRole: 'Change Role',

        // Messages
        noArticles: 'No Articles',
        noSearchResults: 'No Search Results',
        articleDeleted: 'Article deleted successfully',
        articleSaved: 'Article saved successfully',
        articlePublished: 'Article published successfully',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',

        // Confirmation
        deleteConfirmTitle: 'Delete Article',
        deleteConfirmMessage: 'Are you sure you want to delete this?',
        cannotUndoAction: 'This action cannot be undone',

        // Login Modal
        welcomeMessage: 'Welcome to TenTV News',
        signInMessage: 'Sign in to continue',
        continueWith: 'Continue with',
        sendLoginLink: 'Send Login Link',
        emailPlaceholder: 'Enter your email',

        // Roles
        viewer: 'Viewer',
        creator: 'Creator',
    }
};

export default translations;
